var map = {
	"./spei12_10_2041-2060_allpct.png": 41600,
	"./spei12_10_2061-2080_allpct.png": 59688,
	"./spei12_10_2081-2100_allpct.png": 65492,
	"./spei12_11_2041-2060_allpct.png": 70004,
	"./spei12_11_2061-2080_allpct.png": 38940,
	"./spei12_11_2081-2100_allpct.png": 13736,
	"./spei12_12_2041-2060_allpct.png": 47368,
	"./spei12_12_2061-2080_allpct.png": 90368,
	"./spei12_12_2081-2100_allpct.png": 48152,
	"./spei12_1_2041-2060_allpct.png": 26824,
	"./spei12_1_2061-2080_allpct.png": 1720,
	"./spei12_1_2081-2100_allpct.png": 2496,
	"./spei12_2_2041-2060_allpct.png": 74708,
	"./spei12_2_2061-2080_allpct.png": 55384,
	"./spei12_2_2081-2100_allpct.png": 15216,
	"./spei12_3_2041-2060_allpct.png": 94752,
	"./spei12_3_2061-2080_allpct.png": 54736,
	"./spei12_3_2081-2100_allpct.png": 47960,
	"./spei12_4_2041-2060_allpct.png": 54776,
	"./spei12_4_2061-2080_allpct.png": 70604,
	"./spei12_4_2081-2100_allpct.png": 62132,
	"./spei12_5_2041-2060_allpct.png": 6400,
	"./spei12_5_2061-2080_allpct.png": 91496,
	"./spei12_5_2081-2100_allpct.png": 35496,
	"./spei12_6_2041-2060_allpct.png": 18928,
	"./spei12_6_2061-2080_allpct.png": 84592,
	"./spei12_6_2081-2100_allpct.png": 74368,
	"./spei12_7_2041-2060_allpct.png": 21756,
	"./spei12_7_2061-2080_allpct.png": 76092,
	"./spei12_7_2081-2100_allpct.png": 58972,
	"./spei12_8_2041-2060_allpct.png": 66776,
	"./spei12_8_2061-2080_allpct.png": 49460,
	"./spei12_8_2081-2100_allpct.png": 6464,
	"./spei12_9_2041-2060_allpct.png": 78552,
	"./spei12_9_2061-2080_allpct.png": 45285,
	"./spei12_9_2081-2100_allpct.png": 6892,
	"./spei3_10_2041-2060_allpct.png": 85924,
	"./spei3_10_2061-2080_allpct.png": 82651,
	"./spei3_10_2081-2100_allpct.png": 8232,
	"./spei3_11_2041-2060_allpct.png": 98104,
	"./spei3_11_2061-2080_allpct.png": 59832,
	"./spei3_11_2081-2100_allpct.png": 62584,
	"./spei3_12_2041-2060_allpct.png": 76060,
	"./spei3_12_2061-2080_allpct.png": 85060,
	"./spei3_12_2081-2100_allpct.png": 70900,
	"./spei3_1_2041-2060_allpct.png": 36368,
	"./spei3_1_2061-2080_allpct.png": 62932,
	"./spei3_1_2081-2100_allpct.png": 77044,
	"./spei3_2_2041-2060_allpct.png": 71492,
	"./spei3_2_2061-2080_allpct.png": 83876,
	"./spei3_2_2081-2100_allpct.png": 29404,
	"./spei3_3_2041-2060_allpct.png": 35780,
	"./spei3_3_2061-2080_allpct.png": 31863,
	"./spei3_3_2081-2100_allpct.png": 6820,
	"./spei3_4_2041-2060_allpct.png": 37944,
	"./spei3_4_2061-2080_allpct.png": 22168,
	"./spei3_4_2081-2100_allpct.png": 41580,
	"./spei3_5_2041-2060_allpct.png": 88164,
	"./spei3_5_2061-2080_allpct.png": 30440,
	"./spei3_5_2081-2100_allpct.png": 11676,
	"./spei3_6_2041-2060_allpct.png": 2599,
	"./spei3_6_2061-2080_allpct.png": 32596,
	"./spei3_6_2081-2100_allpct.png": 17844,
	"./spei3_7_2041-2060_allpct.png": 6248,
	"./spei3_7_2061-2080_allpct.png": 77612,
	"./spei3_7_2081-2100_allpct.png": 72860,
	"./spei3_8_2041-2060_allpct.png": 62471,
	"./spei3_8_2061-2080_allpct.png": 29024,
	"./spei3_8_2081-2100_allpct.png": 6912,
	"./spei3_9_2041-2060_allpct.png": 54748,
	"./spei3_9_2061-2080_allpct.png": 41864,
	"./spei3_9_2081-2100_allpct.png": 47181,
	"./spei6_10_2041-2060_allpct.png": 53812,
	"./spei6_10_2061-2080_allpct.png": 28368,
	"./spei6_10_2081-2100_allpct.png": 602,
	"./spei6_11_2041-2060_allpct.png": 29472,
	"./spei6_11_2061-2080_allpct.png": 17604,
	"./spei6_11_2081-2100_allpct.png": 51168,
	"./spei6_12_2041-2060_allpct.png": 31564,
	"./spei6_12_2061-2080_allpct.png": 60540,
	"./spei6_12_2081-2100_allpct.png": 32304,
	"./spei6_1_2041-2060_allpct.png": 41908,
	"./spei6_1_2061-2080_allpct.png": 1236,
	"./spei6_1_2081-2100_allpct.png": 93524,
	"./spei6_2_2041-2060_allpct.png": 78164,
	"./spei6_2_2061-2080_allpct.png": 72428,
	"./spei6_2_2081-2100_allpct.png": 99805,
	"./spei6_3_2041-2060_allpct.png": 57316,
	"./spei6_3_2061-2080_allpct.png": 79120,
	"./spei6_3_2081-2100_allpct.png": 95820,
	"./spei6_4_2041-2060_allpct.png": 76632,
	"./spei6_4_2061-2080_allpct.png": 55797,
	"./spei6_4_2081-2100_allpct.png": 40260,
	"./spei6_5_2041-2060_allpct.png": 59088,
	"./spei6_5_2061-2080_allpct.png": 95452,
	"./spei6_5_2081-2100_allpct.png": 20028,
	"./spei6_6_2041-2060_allpct.png": 51132,
	"./spei6_6_2061-2080_allpct.png": 99632,
	"./spei6_6_2081-2100_allpct.png": 14588,
	"./spei6_7_2041-2060_allpct.png": 11375,
	"./spei6_7_2061-2080_allpct.png": 54180,
	"./spei6_7_2081-2100_allpct.png": 1700,
	"./spei6_8_2041-2060_allpct.png": 71389,
	"./spei6_8_2061-2080_allpct.png": 5048,
	"./spei6_8_2081-2100_allpct.png": 1320,
	"./spei6_9_2041-2060_allpct.png": 25344,
	"./spei6_9_2061-2080_allpct.png": 29836,
	"./spei6_9_2081-2100_allpct.png": 33152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3135;